import {useState} from 'react';
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { BranchAction } from "../../../Store/Branch";
import GetBranchDetailsWithCode from "../../../CustomComponents/GetBranchDetailsWithCode";

const BasicInformation = (props) => {
  const dispatch = useDispatch();
  const losCustomerData1 = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );
  const [losCustomerData, setLosCustomerData] = useState(losCustomerData1)
  useEffect(() => {
    dispatch(BranchAction.updateInitialLoad(false));
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.code === losCustomerData?.branchCode;
    });
    setTimeout(()=>{
      dispatch(BranchAction.updateHeaderBranchDetails(branchCodeValue.label));
    },500)
  }, [losCustomerData]);
  const BasicContent = (
    <>
      <Box component="form">
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Branch"
              id="branch"
              variant="standard"
              value={losCustomerData?.branch}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Application Number"
              id="applicationNum"
              variant="standard"
              value={losCustomerData?.applicationNum}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Applicant Name"
              id="applicantName"
              variant="standard"
              value={losCustomerData?.customerName}
              type="text"
              placeholder=""
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Sanction Status"
              id="sanctionStatus"
              variant="standard"
              value={losCustomerData.losStatus}
              type="text"
              placeholder=""
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Application Date"
              id="applicationDate"
              variant="standard"
              value={dayjs(losCustomerData.applicationDate).format("DD/MM/YYYY")}
              type="text"
              placeholder=""
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Rate of Interest(%)"
              id="roi"
              variant="standard"
              value={losCustomerData.rateOfInterest}
              type="text"
              placeholder=""
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Sanctioned Loan Amount (₹)"
              id="sanctionAmt"
              variant="standard"
              value={parseInt(losCustomerData?.sanctionAmt).toLocaleString(
                "en-IN"
              )}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Loan Type"
              id="loanType"
              variant="standard"
              value={losCustomerData?.loanType}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Earlier Disbursement Amount (₹)"
              id="earlierDisbursementAmount"
              variant="standard"
              value={parseInt(
                props.disbursementDetailTabValue.earlierDisbAmt
              ).toLocaleString("en-IN")}
              type="text"
              placeholder="Enter Earlier Disbursement Amount"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Sanction Amount"
              id="sanctionAmt"
              variant="standard"
              value={losCustomerData.sanctionAmt}
              type="text"
              placeholder=""
            />
          </Grid> */}
        </Grid>
      </Box>
    </>
  );

  return (
    <>
      <AccordianContainer
        title={props.screenTitle}
        initialOpen={true}
        setAccordianOpen={props.setAccordianOpen}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            marginBottom: "16px",
            marginTop: "-2%",
          }}
        >
          {BasicContent}
        </Box>
      </AccordianContainer>
    </>
  );
};

export default BasicInformation;
